import { FC, SVGProps } from 'react';

export const DropDownIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M15.2929 19.2929L9.70713 13.7071C9.07716 13.0771 9.52333 12 10.4142 12H21.5858C22.4767 12 22.9229 13.0771 22.2929 13.7071L16.7071 19.2929C16.3166 19.6834 15.6834 19.6834 15.2929 19.2929Z"
			fill="currentColor"
		/>
	</svg>
);
